import { render, staticRenderFns } from "./detail-comic.vue?vue&type=template&id=6b554fdc"
import script from "./detail-comic.vue?vue&type=script&lang=tsx"
export * from "./detail-comic.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports